"use client"

import { usePathname } from "next/navigation"
import { SignInButton, SignUpButton, SignedIn, SignedOut, UserButton } from "@clerk/nextjs"

import AppBreadCrumbs from "@/components/AppBreadCrumbs"
import { menuItems } from "@/components/AppSidebar"

import Link from "next/link"

import { Menu } from "lucide-react"

import useUserStore from "@/store/userStore"


const AppMobileDrawerMenu = ({ children }) => {

    const { userCredits, userPlan, userEmail } = useUserStore()
    const pathname = usePathname()

    return (
        <div className="flex-1">
            <div className="drawer">
                <input id="my-drawer-3" type="checkbox" className="drawer-toggle" />
                <div className="drawer-content flex flex-col">
                    {/* Navbar */}
                    <div className="navbar w-full">
                        {/* menu button for mobile */}
                        <div className="flex-none lg:hidden">
                            <label htmlFor="my-drawer-3" aria-label="open sidebar" className="btn btn-square btn-ghost">
                                <Menu size={24} />
                            </label>
                        </div>

                        {/* breadcrumb */}
                        <div className="mx-2 flex-1 px-4 hidden md:block">
                            <AppBreadCrumbs />
                        </div>

                        {/* USER info */}
                        <div className="hidden flex-none lg:block">
                            <div className="flex items-center gap-8">
                                {/* <NavItems /> */}
                                <SignedOut>
                                    <div className="flex items-center gap-2">
                                        <SignInButton mode="modal">
                                            <button className="btn-signin">Sign In</button>
                                        </SignInButton>
                                    </div>
                                </SignedOut>

                                <SignedIn>
                                    <Link href={'/pricing'} className='flex items-center gap-2 bg-warning rounded-full pl-1 pr-3 py-1'>
                                        <div className='text-neutral text-sm font-bold flex items-center gap-1'>
                                            <span className="bg-neutral p-1 rounded-full"><img src="/credits.svg" alt="" className='w-4 h-4' /></span>
                                            {userCredits !== null ? userCredits : (<div className="loading loading-spinner loading-xs text-neutral/50"></div>)}
                                        </div>
                                        {/* <div className="w-1 h-4 border-l border-neutral-900"></div> */}
                                        {/* <div className='text-neutral text-sm font-bold mr-2'>Upgrade</div> */}
                                    </Link>
                                    <div className="flex flex-col items-end">
                                        <div className="text-sm">{userEmail}</div>
                                        <div className="badge badge-xs badge-primary font-bold">{userPlan !== null ? userPlan.split('-')[0].charAt(0).toUpperCase() + userPlan.split('-')[0].slice(1) : "--"}</div>
                                    </div>
                                    <UserButton />
                                </SignedIn>
                            </div>
                        </div>
                    </div>

                    {/* Page content here */}
                    {children}
                </div>

                {/* Drawer Menu For Mobile */}
                <div className="drawer-side">
                    <label htmlFor="my-drawer-3" aria-label="close sidebar" className="drawer-overlay"></label>

                    <div className="menu bg-base-200 min-h-full w-80 p-4">
                        <a href="/" className="flex items-center justify-start p-4 gap-2 mb-4">
                            <img src="/logo.svg" alt="logo" className="w-10 h-10" />
                            <div className="font-bold">LipSync.Show</div>
                        </a>

                        <ul>
                            {/* Sidebar content here */}
                            {menuItems.map((item) => (
                                <li key={item.href}>
                                    <Link href={item.href} className={`py-6 px-5 ${pathname === item.href ? "bg-base-300" : ""}`}>
                                        <item.icon size={18} />
                                        <span className="ml-2 text-xl">{item.label}</span>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AppMobileDrawerMenu